import { HOMEBUILDER_STAGES } from "@/data/homebuilderData";
import { DataPointList } from "./DataPointList";

interface HomebuilderApprovalsStepProps {
  selectedKeys: Set<string>;
  onToggle: (key: string) => void;
  onRequestMissing: () => void;
}

export function HomebuilderApprovalsStep({ selectedKeys, onToggle, onRequestMissing }: HomebuilderApprovalsStepProps) {
  const stage = HOMEBUILDER_STAGES.find(s => s.id === "hb-approvals")!;

  return (
    <div className="space-y-6 pb-20">
      <div className="space-y-1">
        <h2 className="text-2xl font-semibold">Permitting</h2>
        <p className="text-muted-foreground">Required permits and review processes for your projects.</p>
      </div>

      <DataPointList dataPoints={stage.dataPoints} selectedKeys={selectedKeys} onToggle={onToggle} onRequestMissing={onRequestMissing} />
    </div>
  );
}
